import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { Component, OnInit } from "@angular/core";
import { VrstaStavki } from './vrsta-stavki';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import value from '*.json';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'yt-vrsta-stavki-update',
    templateUrl:'./vrsta-stavki-update.component.html'
})

export class VrstaStavkiUpdateComponent
extends BaseUpdateComponent<VrstaStavki>
implements OnInit{

    constructor(
        protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
    ){
        super(activatedRoute, baseDataService, toastrService, translateService);
    }


    rbItems=[];
    // rbItems=[
    //     {
    //         Name:this.translateService.get('VRSTASTAVKI.ROBA.SINGULAR')["value"],
    //         Value: 'R'
    //     },
    //     {
    //         Name:this.translateService.get('VRSTASTAVKI.USLUGA.SINGULAR')["value"],
    //         Value: 'U'
    //     }
    // ];
    ngOnInit(){
        super.ngOnInit();


        this.addValidatorToFc('Sifra',Validators.required, 'required', 'VRSTASTAVKI.SIFRA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Sifra',Validators.maxLength(8), 'maxlength', 'VRSTASTAVKI.SIFRA.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('Naziv',Validators.required, 'required', 'VRSTASTAVKI.NAZIV.VALIDATION.REQUIRED');
        this.addValidatorToFc('Naziv',Validators.maxLength(200), 'maxlength', 'VRSTASTAVKI.NAZIV.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('TarifaID',Validators.required, 'required', 'VRSTASTAVKI.TARIFA.VALIDATION.REQUIRED');
        //this.addValidatorToFc('Cena',Validators.min(0.001),'min','VRSTASTAVKI.CENA.VALIDATION.MIN');
        this.addValidatorToFc('JedinicaMereID',Validators.required, 'required', 'VRSTASTAVKI.JEDINICAMERE.VALIDATION.REQUIRED');
        //this.addValidatorToFc('RobaUsluga',Validators.pattern('^R|U$'), 'pattern', 'VRSTASTAVKI.ROBAUSLUGA.VALIDATION.PATTERN');
        this.addValidatorToFc('RobaUsluga',Validators.required, 'required', 'VRSTASTAVKI.ROBAUSLUGA.VALIDATION.REQUIRED');
        this.addValidatorToFc('RobaUsluga',Validators.maxLength(1), 'maxlength', 'VRSTASTAVKI.ROBAUSLUGA.VALIDATION.MAXLENGTH');

        this.translateService.get(['VRSTASTAVKI.ROBA.SINGULAR', 'VRSTASTAVKI.USLUGA.SINGULAR'])
        .subscribe(translate => {
            this.rbItems=[
                {
                    Name : translate['VRSTASTAVKI.ROBA.SINGULAR'],
                    Value : 'R'
                },
                {
                    Name : translate['VRSTASTAVKI.USLUGA.SINGULAR'],
                    Value : 'U'
                }
            ];
                                
        });
        
    }

    Load(ID: number, LanguageID: number=1): Observable<number> {
        this.SavedItem = null;
        let parameters: QueryParameter[] = [];
        parameters.push(new QueryParameter('id', ID));
        parameters.push(new QueryParameter('languageId', LanguageID));
        return this.baseDataService.Get(
            this.modelData.MainList.ModelName
            // , "getByIdAndLanguageid"
            , "get"
            , parameters
            , this.modelData.MainList.ModelClass
            )
            .pipe(map((data: VrstaStavki[]) => {
                this.Item = data[0];
                this.baseFormGroup.setValue(this.Item);
                this.SavedItem = this.baseFormGroup.getRawValue();
                this.IDProcessed.next(true);
                return this.Item.ID;
            }))
    }
}